import { NoValue } from '@vaaas/fpts/data';

export type IWrappedParameter<T = unknown> = ReturnType<typeof wrapped_parameter<T>>;

/** wrappes a parameter in a getter/setter function so that it can be passed by reference
 *
 * calling the getter/setter with an argument modifies the internal state
 *
 * calling the getter/setter without an argument fetches the internal state
 *
 * @param v the initial value
 * @param x the updated value if setting, or nothing if getting
 * @returns the internal value if getting, or the updated value if setting
 *
 * @example const test = wrapped_parameter(0)
 * const internal = test() // 0
 * const updated = test(15) // updates internal value to 15, returns 15
 * const internal2 = test() // 15 now
 */
export const wrapped_parameter = <T>(v: T) => (x: T | typeof NoValue = NoValue) => x === NoValue ? v : v = x;
